// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type StartDocumentCollectionAiChatMutationVariables = Types.Exact<{
  input: Types.StartDocumentCollectionAiChatInput;
}>;


export type StartDocumentCollectionAiChatMutation = { __typename?: 'Mutation', startDocumentCollectionAiChat: { __typename?: 'AiChatSession', id: string, workspaceId: string, scopeType: Types.AiChatScopeType, status: Types.AiChatSessionStatus, scopeDocumentCollectionId?: string | null, title: string, createdAt: any, updatedAt: any } };


export const StartDocumentCollectionAiChatDocument = gql`
    mutation StartDocumentCollectionAiChat($input: StartDocumentCollectionAiChatInput!) {
  startDocumentCollectionAiChat(input: $input) {
    id
    workspaceId
    scopeType
    status
    scopeDocumentCollectionId
    title
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useStartDocumentCollectionAiChatMutation__
 *
 * To run a mutation, you first call `useStartDocumentCollectionAiChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDocumentCollectionAiChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDocumentCollectionAiChatMutation, { data, loading, error }] = useStartDocumentCollectionAiChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartDocumentCollectionAiChatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartDocumentCollectionAiChatMutation, StartDocumentCollectionAiChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartDocumentCollectionAiChatMutation, StartDocumentCollectionAiChatMutationVariables>(StartDocumentCollectionAiChatDocument, options);
      }
export type StartDocumentCollectionAiChatMutationHookResult = ReturnType<typeof useStartDocumentCollectionAiChatMutation>;
export type StartDocumentCollectionAiChatMutationResult = ApolloReactCommon.MutationResult<StartDocumentCollectionAiChatMutation>;